import type { JSX } from "solid-js";
import { holdFocus } from "./hold";

/** The one dialog (design 15 §10): the backdrop, the box with its name, the focus taken in and given back (ui/hold). onClose is
 *  what Escape does, and a press outside too unless `alert` says the dialog must be answered by its own buttons. */
export function Dialog(props: { label: string; class?: string; alert?: boolean; onClose?: () => void; children: JSX.Element }) {
  return (
    <div class="dialog-backdrop" onClick={() => !props.alert && props.onClose?.()}>
      <div
        class={props.class ? `dialog ${props.class}` : "dialog"}
        role={props.alert ? "alertdialog" : "dialog"}
        aria-modal="true"
        aria-label={props.label}
        tabindex="-1"
        onClick={(e) => e.stopPropagation()}
        ref={(el) => holdFocus(el, props.onClose)}
      >
        {props.children}
      </div>
    </div>
  );
}
